export var DRAG_X_OFFSET = -10;
export var DRAG_Y_OFFSET = 5;
//# sourceMappingURL=folderNodeDragConstants.js.map